import { id, list, project, retrieveListError, zone } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRetrieveListError(listId) {
      const req = getState().find(({ list }) => list.uuid === listId);

      return req ? req.error : retrieveListError;
    },
    getList(listId) {
      const res = getState().find(({ id }) => id === listId);

      return res
        ? res.list
        : {
            ...list,
            uuid: listId,
            list: { ...list, uuid: id },
            project: { ...project, uuid: id },
            zone: { ...zone, uuid: id },
          };
    },
    isListRetrievalRequestFailure(listId) {
      const res = getState().find(({ id }) => id === listId);

      return res ? res.request.isFailure : false;
    },
    isListRetrievalRequestPending(listId) {
      const res = getState().find(({ id }) => id === listId);

      return res ? res.request.isPending : false;
    },
    isListRetrievalRequestSuccess(listId) {
      const res = getState().find(({ id }) => id === listId);

      return res ? res.request.isSuccessful : false;
    },
    hasRetrievedList(listId) {
      const res = getState().find(({ id }) => id === listId);

      return res ? res.request.isSuccessful || res.request.isFailure : false;
    },
  };
}

export { createSelector };
